module.exports = __webpack_public_path__ + "media/img/payments/payment-wrapper-aa7e16b0a626102de8c2624c2cec34c7.svg";